import { render, staticRenderFns } from "./setBankCard.vue?vue&type=template&id=19d9e79a&scoped=true"
import script from "./setBankCard.vue?vue&type=script&lang=js"
export * from "./setBankCard.vue?vue&type=script&lang=js"
import style0 from "./setBankCard.vue?vue&type=style&index=0&id=19d9e79a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d9e79a",
  null
  
)

export default component.exports